import { render, staticRenderFns } from "./ToolPanelLinks.vue?vue&type=template&id=0d52496c"
import script from "./ToolPanelLinks.vue?vue&type=script&lang=js"
export * from "./ToolPanelLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports